import { useState } from "react";
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";

export const useReclamo = () => {
    const reclamoDefault = {
        codDocumento: 1,
        nroDocumento: '',
        nomPersona: '',
        apePaterno: '',
        apeMaterno: '',
        telefono: '',
        email: '',
        departamento: '',
        provincia: '',
        distrito: '',
        codEmpresaGeneral: 0,
        nomEmpresaGeneral: "",
        codTipoConsulta: 1,
        detalleReclamo: ''
    }
    
    const [ reclamo, setReclamo ] = useState(reclamoDefault);
    

    const guardarReclamo = async () => {
        console.log("GUARDAR RECLAMO")
        const variable =['nroDocumento','nomPersona','apePaterno','apeMaterno','detalleReclamo']
        var contador =0
        variable.forEach((element,i)  => {
            if(document.getElementById(`input${element}`)?.value == ''){
                document.getElementById(`input${element}`).focus()
                contador++
            }
        });
        if(contador>0){
            notify('No puede dejar el campo vacío','error')
            return
        }
        const response = await Fetch({
            // url: 'https://beedronewebapi.abexacloud.com/api/Claim',
            url: 'https://atuwebapi.plaminoficial.com/api/Reporte/registrarIncidencia',
            method: 'POST',
            body: JSON.stringify({
                codReclamoTipo: reclamo.codTipoConsulta,
                uid: "UnregisteredUser",
                mensajeReclamo: reclamo.detalleReclamo,
                latitudRegistro: 0,
                longitudRegistro: 0,
                codEmpresa: reclamo.codEmpresaGeneral,
                nomEmpresa: reclamo.nomEmpresaGeneral,
                codUnidad: 0,
                placaUnidad: "",
                padronUnidad: 0,
                numCelular: reclamo.telefono,
                numeroDocumento: reclamo.nroDocumento
            })
        });
        if (response.isValid){
            setReclamo(reclamoDefault);
            notify(response.content,'success');
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }else{
            notify(response.exceptions[0].description, 'error')
        }
    }

    const editarValorReclamo = (key,value) =>{
        setReclamo(reclamo => {
            return {
                ...reclamo,
                [key]: value
            }
        });
    }
    return {reclamo,  guardarReclamo, editarValorReclamo };
}